import styled from 'styled-components/macro';

export const ItemContainer = styled.div`
  @media screen and (max-width: 387px) {
    padding-left: 20px !important;
  }
`;

export const DeleteBox = styled.div`
  & .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;

    & .question {
      margin-bottom: 15px;
    }

    & .button-box {
      display: flex;
      & .button {
        transition: all 0.25s ease-in-out;
        cursor: pointer;
        padding: 10px 15px;
        font-weight: bold;
        border-radius: 10px;
        appearance: none;

        &:active {
          transform: scale(0.96);
        }
      }
      & .button-confirm {
        margin-right: 10px;
        color: white;
        background: #ea4e3d;
        &:hover {
          opacity: 0.85;
        }
      }

      & .button-cancel {
        color: rgba(0, 0, 0, 0.35);
        font-weight: normal;
        background: rgba(0, 0, 0, 0.15);
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
`;

export const FilterList = styled.div`
  transition: all 0.25s ease-in-out;
  background: white;
  display: flex;
  flex-direction: column;
  border-radius: 20px;

  ${({ noMarginRight, isMobile }) =>
    noMarginRight && (isMobile ? `margin-right: 10px;` : `margin-right: 15px;`)}

  ${({ isMobile }) => isMobile && `margin-top: 10px;`}


  cursor: pointer;

  padding: 20px;
  box-sizing: border-box;
  box-shadow: 0 0 10px 3px rgb(0 0 0 / 25%);

  width: calc(100vw / 7);
  @media screen and (max-width: 1366px) {
    width: calc(100vw / 6);
  }
  @media screen and (max-width: 1150px) {
    width: calc(100vw / 5);
  }
  @media screen and (max-width: 1065px) {
    width: calc(100vw / 6);
    padding: 10px 20px 20px 20px;
  }
  @media screen and (max-width: 767px) {
    width: 50%;
  }
  @media screen and (min-width: 371px) and (max-width: 409px) {
    padding: 25px 15px 25px 10px;
  }
  @media screen and (min-width: 410px) and (max-width: 472px) {
    padding: 25px 20px 25px 10px;
  }
  @media screen and (min-width: 473px) and (max-width: 767px) {
    padding: 25px 25px 25px 25px;
  }

  ${({ isActive, color_l2 }) =>
    !isActive &&
    `
    &:hover { background: ${color_l2}!important; }
  `}

  &:active {
    transform: scale(0.97);
  }

  ${({ isActive, color_l2 }) =>
    isActive &&
    `
    background: ${color_l2}!important;

  `}
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media screen and (min-width: 768px) and (max-width: 1065px),
      (max-width: 370px) {
      margin-bottom: 5px;
    }

    & > div:first-child {
      display: flex;
      align-items: center;
      & .icon {
        display: flex;
        align-items: center;
        padding: 7px;
        margin-right: 10px;
        border-radius: 50%;
        color: white;
        box-shadow: 2px 2px 5px rgb(0 0 0 / 20%);
        background: ${({ color, color_D2 }) =>
          `linear-gradient(180deg, ${color} 32.22%, ${color_D2} 120%);`};
        @media screen and (min-width: 768px) and (max-width: 1065px),
          (max-width: 370px) {
          padding: 4px;
          font-size: 13px;
        }
      }
      & .title {
        margin: 0;
        @media screen and (min-width: 768px) and (max-width: 1065px),
          (max-width: 370px) {
          display: none;
        }
      }
    }

    & > div:nth-child(2) {
      display: flex;
      align-items: center;
      margin-left: 25px;

      @media screen and (min-width: 371px) and (max-width: 389px) {
        margin-left: 12px;
      }
      @media screen and (min-width: 390px) and (max-width: 409px) {
        margin-left: 20px;
      }
    }
  }
  & > div:nth-child(2) {
    @media screen and (min-width: 768px) and (max-width: 1065px),
      (max-width: 370px) {
      display: flex;
    }
    display: none;
    justify-content: center;
    & .titleSmallScreen {
      margin: 0;
    }
  }
`;

export const ColorBox = styled.div`
  transition: all 0.2s ease-in-out;
  border-radius: 50%;
  padding: 2px;
  border-width: 2px;
  cursor: pointer;
  border-style: solid;
  aspect-ratio: 1 / 1;
  display: flex;

  width: 32px;
  height: 32px;

  &:hover {
    opacity: 0.75;
  }

  &:active {
    opacity: 1;
  }

  & > div {
    border-radius: 50%;
    flex: 1;
    aspect-ratio: 1 / 1;

    background: ${({ color }) => color};
  }

  border-color: ${({ listColor, index, color }) =>
    listColor == index ? color : 'transparent'};
`;

export const ColorContainer = styled.div`
  gap: 16px !important;
`;
